import React, { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../hooks/useApi';
import ParentDisciplineTab from '../../components/parent/ParentDisciplineTab';
import LoadingSpinner from '../../components/common/LoadingSpinner';

const ParentDisciplinePage = () => {
    const { get } = useApi();
    const [selectedChildId, setSelectedChildId] = useState('');

    const { data: parent, isLoading } = useQuery({
        queryKey: ['parent', 'me'],
        queryFn: () => get('/api/parents/me/'),
        staleTime: 30 * 60 * 1000,
    });

    useEffect(() => {
        if (parent?.children?.length > 0 && !selectedChildId) {
            const savedId = localStorage.getItem('parent_selected_child_id');
            const found = parent.children.find(c => String(c.id) === savedId);
            if (found) {
                setSelectedChildId(String(found.id));
            } else {
                setSelectedChildId(String(parent.children[0].id));
            }
        }
    }, [parent, selectedChildId]);

    const handleChildSelect = (childId) => {
        setSelectedChildId(childId);
        localStorage.setItem('parent_selected_child_id', childId);
    };

    if (isLoading) {
        return (
            <div className="max-w-7xl mx-auto px-4 py-16 flex justify-center">
                <LoadingSpinner />
            </div>
        );
    }

    const children = parent?.children || [];

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
            {/* Discipline Tab component with integrated scholar filter */}
            <ParentDisciplineTab 
                childrenList={children}
                initialChildId={selectedChildId}
                onChildChange={handleChildSelect}
            />
        </div>
    );
};

export default ParentDisciplinePage;
